import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

import constants from 'utils/constants';
import notiPill from 'images/noti_case_pill.png';
import notiReward from 'images/noti_case_reward.png';
import notiChallenge from 'images/noti_case_challenge.png';
import notiMotivation from 'images/noti_case_motivation.png';

export default function ConfirmNotificationScene({
    onSubmit, onDeny
}) {
    return (
        <ConfirmNotificationBlock>
            <Content>
                <Title>도움되는 것만<br />쏙쏙 알려드릴까요?</Title>

                <NotiCaseBlock>
                    <NotiCaseList>
                        <NotiCase>
                            <Emoticon src={notiPill} length={28} mr={12} ml={-11} />
                            <NotiCaseText>영양제 먹는걸 깜박했을 때</NotiCaseText>
                        </NotiCase>
                        <NotiCase>
                            <Emoticon src={notiReward} length={34} mr={9} ml={-18} />
                            <NotiCaseText>상금 이벤트가 열렸을 때</NotiCaseText>
                        </NotiCase>
                        <NotiCase>
                            <Emoticon src={notiChallenge} length={35} mr={11} ml={-10} /> 
                            <NotiCaseText>챌린지 시작 전에 안까먹게</NotiCaseText>
                        </NotiCase>
                        <NotiCase>
                            <Emoticon src={notiMotivation} length={35} mr={10} ml={-19} /> 
                            <NotiCaseText>동기부여를 받고 싶을 때</NotiCaseText>
                        </NotiCase>
                    </NotiCaseList>
                    <DimmedArea />
                </NotiCaseBlock>
            </Content>
            <ButtonBlock>
                <Button onClick={onSubmit}>네, 좋아요!</Button>
                <SkipButton onClick={()=>{if(onDeny)onDeny()}} >알림 안받을래요</SkipButton>
            </ButtonBlock>
        </ConfirmNotificationBlock>
    )
}

const ConfirmNotificationBlock = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: calc(100vh - calc(100vw * (142 / 375)));
    overflow: scroll;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: calc(100vw * (46 / 375));
`;

const Title = styled.div`
    font-weight: 700;
    font-size: calc(100vw * (24 / 375));
    line-height: calc(100vw * (35 / 375));
    text-align: center;
    color: #121212;
    margin-top: calc(100vw * (62 / 375));
`;

const NotiCaseBlock = styled.div`
    width: 100%;
    margin-top: calc(100vw * (49 / 375));
    position: relative;
    z-index: 1;
`;

const NotiCaseList = styled.div`
    width: 100%;
`;

const NotiCase = styled.div`
    width: calc(100vw * (314 / 375));
    height: calc(100vw * (83 / 375));
    background-color: #FFFFFF;
    box-shadow: 0px 0px calc(100vw * (20 / 375)) rgba(191, 191, 191, 0.5);
    border-radius: calc(100vw * (15 / 375));
    margin: 0 auto;
    
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    :not(:last-child) {
        margin-bottom: calc(100vw * (15 / 375));
    }

    :last-child {
        box-shadow: 0px 0px calc(100vw * (14 / 375)) rgba(191, 191, 191, 0.5);
    }
`;

const Emoticon = styled.img`
    width: calc(100vw * (${({ length }) => length} / 375));
    height: calc(100vw * (${({ length }) => length} / 375));
    margin-right: calc(100vw * (${({ mr }) => mr} / 375));
    margin-left: calc(100vw * (${({ ml }) => ml} / 375));
`;

const NotiCaseText = styled.div`
    font-weight: 600;
    font-size: calc(100vw * (18 / 375));
    line-height: calc(100vw * (22 / 375));
    color: #4E4E4E;
`;

const DimmedArea = styled.div`
    position: absolute;
    bottom: calc(100vw * (-13 / 375));
    width: 100%;
    height: calc(100vw * (96 / 375));
    background: linear-gradient(to bottom, #F7F7F7 15%, rgba(247, 247, 247, 0.63) 65%, rgba(247, 247, 247, 0) 112%);
    transform: rotate(180deg);
    z-index: 2;
`;

const ButtonBlock = styled.div`
    width: 100%;
    margin-bottom: calc(100vw * (35 / 375));
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    bottom: 0;
    z-index: 3;
    padding: 0 calc(100vw * (23 / 375))
`;

const Button = styled.button`
    width: 100%;
    padding: calc(100vw * (16 / 375)) 0;
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (23 / 375));
    font-weight: 700;
    background-color: #FFCF19;
    border-radius: calc(100vw * (6 / 375));
`;

const SkipButton = styled(Link)`
    font-size: calc(100vw * (16 / 375));
    line-height: calc(100vw * (23 / 375));
    font-weight: 500;
    margin-top: calc(100vw * (29 / 375));
    color: #989898;
`;